import React, { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelTres.scss";

// Const
import { BG_TILES } from "../../utils/consts";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const LevelTres = (props) => {
  const [tileState, setTiles] = useState(BG_TILES);
  const [lastPosition, setLastPosition] = useState({ x: -1, y: -1, index: -1 });
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    firstClickTime: 0,
    boxesClicked: [],
    allBoxesTime: 0,
    firstLineTime: 0,
    secondLineTime: 0,
    attempts: 1,
    totalTime: 0,
    totalHints: 0,
    eachHintTime: 0,
    timeAfterLastHint: 0,
    clicksAfterLastHint: 0,
  });

  // Attempts
  const [attempts, setAttempts] = useState(0);

  // Clicks
  const [clicks, setClicks] = useState(0);

  // Timer
  const [timer, setTimer] = useState(0);

  // Timer increase
  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  // Check if won
  useEffect(() => {
    let index = 0;
    while (index < tileState.length) {
      if (tileState[index].filled === false) {
        setWon(false);
        break;
      }
      index += 1;
    }
    if (index === tileState.length) setWon(true);
  }, [tileState]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        getDataPoints("up", won);
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: 3,
                levelName: 'Compass',
                firstClickTime: dataPoints.firstClickTime,
                allBoxesTime: dataPoints.allBoxesTime,
                firstLineTime: dataPoints.firstLineTime,
                secondLineTime: dataPoints.secondLineTime,
                attempts: attempts,
                totalTime: timer,
                totalClicks: clicks,
                isLevelCleared: true,
                isLevelSkipped: false,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
                timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
              }
            ],
          }
        }
        console.log(finalObj)
        sendResult(finalObj)
        setMove(true);
      }
    }, 500);
  }, [won]);

  const getDataPoints = (direction, tempWon) => {
    let tempDataPoints = { ...dataPoints };

    // Time taken to first click on any 4 of the boxes
    if (dataPoints.firstClickTime === 0) {
      tempDataPoints.firstClickTime = timer;
    }

    // Time taken to click all 4 boxes
    if (dataPoints.allBoxesTime === 0) {
      if (!dataPoints.boxesClicked.includes(direction)) {
        let tempArr = [...dataPoints.boxesClicked];
        tempArr.push(direction);
        tempDataPoints.boxesClicked = tempArr;
      }
      if (tempDataPoints.boxesClicked.length === 4) {
        tempDataPoints.allBoxesTime = timer;
      }
    }

    // Total Attempts
    if (tempWon) {
      tempDataPoints.attempts = attempts;
      tempDataPoints.totalTime = timer;
    }

    setDataPoints(tempDataPoints);
  };

  // Select direction
  const fillTile = (direction) => {
    if (lastPosition.x === -1 && lastPosition.y === -1) {
      let tempState = [...tileState];
      getDataPoints(direction);
      tempState[0].filled = true;
      setLastPosition({ x: 0, y: 0, index: 0 });
      setTiles(tempState);
    } else {
      switch (direction) {
        case "right":
          moveTile("right");
          break;
        case "down":
          moveTile("down");
          break;
        case "left":
          moveTile("left");
          break;
        case "up":
          moveTile("up");
          break;
        default:
          break;
      }
    }
  };

  // Move tile to passed direction
  const moveTile = (direction) => {
    let tempPosition = { ...lastPosition };
    setClicks(clicks + 1);
    getDataPoints(direction);

    // Check if position in bounds
    if (
      tempPosition[direction === "right" || direction === "left" ? "x" : "y"] >
      4 &&
      tempPosition[direction === "right" || direction === "left" ? "x" : "y"] <
      0
    ) {
      return;
    } else {
      // Check for addition or substraction of position values
      // then set next required position
      if (direction === "right" || direction === "down") {
        tempPosition[
          direction === "right" || direction === "left" ? "x" : "y"
        ] =
          tempPosition[
          direction === "right" || direction === "left" ? "x" : "y"
          ] + 1;
      } else {
        tempPosition[
          direction === "right" || direction === "left" ? "x" : "y"
        ] =
          tempPosition[
          direction === "right" || direction === "left" ? "x" : "y"
          ] - 1;
      }
      let tempIndex = 0;
      let tempState = [...tileState];

      // Search for next valid position index
      tempState.forEach((item, index) => {
        if (item.x === tempPosition.x && item.y === tempPosition.y) {
          tempIndex = index;
        }
      });

      // If position TRUE then change to original state
      if (tempState[tempIndex].filled === true) {
        tileState.forEach((item, index) => {
          tempState[index].filled = false;
        });
        setTiles(tempState);
        setLastPosition({ x: -1, y: -1, index: -1 });
        setAttempts(attempts + 1);
        return;
      }

      // change tile filled state to TRUE
      tempState[tempIndex].filled = true;

      // Set last position
      setLastPosition({ ...tempPosition, ...{ index: tempIndex } });

      setTiles(tempState);
    }
  };

  return (
    <div className="component-level-tres">
      {move && <LevelComplete levelNum={6} />}
      <Navbar won={won} levelNum={6} />
      <div className="color-div">
        <div className="game-div-tres">
          <div className="right-btn btn" onClick={() => fillTile("right")}>
            <div></div>
          </div>
          <div className="down-btn btn" onClick={() => fillTile("down")}>
            <div></div>
          </div>
          <div className="left-btn btn" onClick={() => fillTile("left")}>
            <div></div>
          </div>
          <div className="up-btn btn" onClick={() => fillTile("up")}>
            <div></div>
          </div>
        </div>
        {tileState.map((item, index) => (
          <div
            key={index}
            className={`bg-tile ${item.filled ? "filled" : ""}`}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default LevelTres;
